export default "__VITE_ASSET__C42yf9si__"